export const contact = '/.netlify/functions/contact';
export const trailerId = '388101404';
